<template>
  <div class="drag-group">
    <span
      draggable="true"
      v-for="(col, index) in columns"
      :key="col.prop || col.type"
      @dragstart="handleDragStart($event, index)"
      @dragend="handleDragEnd"
      @dragover="handleDragOver($event, index)"
      @dragleave="handleDragLeave"
      class="drag-group-item"
      :class="{ fixed: col.fixed }"
    >
      <slot v-bind="col">
        {{ col.label }}
        <i class="iconfont mg-icon-bianqianguding" v-if="col.fixed" />
        <i class="iconfont mg-icon_bianji_gaojitongji" v-else-if="col.edit" />
        <i class="iconfont mg-icon_delete" v-else @click="handleDelete(col)"></i>
      </slot>
    </span>
  </div>
</template>

<script>
  import { addClass, removeClass } from 'element-ui/src/utils/dom'
  export default {
    props: {
      ghostClass: String,
      list: Array,
    },
    data() {
      return {
        columns: [],
      }
    },
    watch: {
      list: {
        handler(values) {
          this.columns = [].concat(values)
        },
        immediate: true,
      },
    },
    methods: {
      handleDelete(col) {
        this.$emit('handleHidden', col)
      },
      handleDragStart(ev, index) {
        this.startIndex = index
        this.startTarget = ev.target
        setTimeout(addClass.bind(null, ev.target, this.ghostClass), 50)
      },
      handleDragOver(ev, index) {
        ev.preventDefault()
        if (this.overTarget !== ev.target) {
          this.overTarget = ev.target
          this.inserIndex = index
          addClass(ev.target, this.ghostClass)
        }
      },
      handleDragLeave(ev) {
        this.overTarget = null
        if (this.startTarget !== ev.target) {
          removeClass(ev.target, this.ghostClass)
        }
      },
      handleDragEnd(ev) {
        if (this.overTarget) {
          const inserItem = this.columns[this.startIndex]
          this.columns.splice(this.startIndex, 1)
          this.columns.splice(this.inserIndex, 0, inserItem)
          removeClass(this.overTarget, this.ghostClass)
          this.$emit('change', this.columns)
        }
        removeClass(ev.target, this.ghostClass)
      },
    },
  }
</script>

<style lang="less" scoped>
  .drag-group {
    overflow: auto;
    background: #fff;
    padding: 10px 0 10px 10px;
    box-sizing: border-box;
    position: relative;
    .drag-group-item {
      position: relative;
      padding: 5px 10px;
      cursor: move;
      margin-right: 10px;
      margin-bottom: 10px;
      display: inline-block;
      background: rgba(37, 42, 61, 0.05);
      &.fixed {
        opacity: 0.6;
        cursor: pointer;
        pointer-events: none;
        i {
          color: #999;
        }
      }
      &:hover {
        .mg-icon_delete {
          display: inline;
        }
      }
      .mg-icon_delete {
        display: none;
        position: absolute;
        top: -5px;
        z-index: 100;
        cursor: pointer;
        color: #e60012;
        font-size: 18px;
      }
    }
  }
</style>
